export default {
  alert: {
    deleteConfirm: 'Bạn chắc chắn muốn xóa những hàng đã chọn?',
    deleteCurrencyConfirm: 'Bạn chắc chắn muốn xóa loại tiền tệ này?',
    deleteTaxConfirm: 'Bạn chắc chắn muốn xóa loại thuế này?',
    deleteChargeFeeConfirm: 'Bạn chắc chắn muốn xóa loại phí dịch vụ này?',
    deleteBankAccountConfirm:
      'Bạn chắc chắn muốn xóa những tài khoản ngân hàng đã chọn?',
    deleteWarningConfirm: 'Bạn chắc chắn muốn xóa những cảnh báo đã chọn?',
    deleteRoutingConfirm: 'Bạn chắc chắn muốn xóa những Routing đã chọn?',
    deleteVipConfirm: 'Bạn chắc chắn muốn xóa VIP này?',
    deleteLanguageConfirm: 'Bạn chắc chắn muốn xóa loại ngôn ngữ này?',
    deleteMarketSegmentConfirm:
      'Bạn chắc chắn muốn xoá phân khúc thị trường này?',
    deleteMarketSegmentGroupConfirm:
      'Bạn chắc chắn muốn xoá nhóm phân khúc thị trường này?',
    deleteSourceGroupConfirm: 'Bạn chắc chắn muốn xoá nhóm nguồn này?',
    deleteSourceConfirm: 'Bạn chắc chắn muốn xoá nguồn này?',
    deleteBuildingConfirm: 'Bạn chắc chắn muốn xóa tòa nhà này?',
    deleteRoomPropertyConfirm: 'Bạn chắc chắn muốn xóa thuộc tính này?',
    deleteRoomConfirm: 'Bạn chắc chắn muốn xóa phòng này?',
    deleteReasonRefuse: 'Bạn chắc chắn muốn xoá lý do này?',
    deleteCustomerProfileConfirm: 'Bạn chắc chắn muốn xoá mẫu ghi chú này?',
    deleteServiceTypeConfirm:
      'Bạn chắc chắn muốn xoá loại sản phẩm, dịch vụ đã chọn?',
    deleteAttributeCategoryConfirm: 'Bạn chắc chắn muốn xoá danh mục này?',
    deleteProductUnitConfirm: 'Bạn chắc chắn muốn xoá đơn vị tính này?',
    deleteSubTransactionConfirm:
      'Bạn chắc chắn muốn xoá loại giao dịch phụ này?',
    deleteTransactionConfirm: 'Bạn chắc chắn muốn xoá loại giao dịch này?',
    deleteConfiguration: 'Bạn chắc chắn muốn xóa cấu hình hình này?',
    deletePackageCategory: 'Bạn chắc chắn muốn xóa danh mục này?',
    deletePackage: 'Bạn chắc chắn muốn xóa gói này?',
    deletePackageDetail: 'Bạn chắc chắn muốn xóa chi tiết gói này?',
    deletePriceCategory: 'Bạn chắc chắn muốn xoá danh mục giá này?',
    deletePriceCode: 'Bạn chắc chắn muốn xóa mã giá này?',
    exitConfirm: 'Bạn chắc chắn muốn thoát?',
    periodNotSavedExitConfirm:
      'Giai đoạn chưa được lưu, bạn chắc chắn muốn thoát?',
    deleteBreakfastCode: 'Bạn chắc chắn muốn xóa mã ăn sáng này?',
    deleteService: 'Bạn chắc chắn muốn xóa dịch vụ này?',
    deleteSurcharge: 'Bạn chắc chắn muốn xóa phụ thu này?',
    deleteRoomServiceGroup:
      'Bạn chắc chắn muốn xóa nhóm dịch vụ buồng phòng này?',
    setMasterConfirm: 'Bạn muốn thay đổi phòng Master?',
    groupCheckoutMaster: 'Bạn muốn checkout phòng đã lựa chọn?',
    deletePackGroup: 'Bạn chắc chắn muốn xóa nhóm gói này?',
    deleteWarehouseConfirm: 'Bạn chắc chắn muốn xóa kho này?',
    deleteReasonCancelConfirm: 'Bạn chắc chắn muốn xóa lý do này?',
    deleteOTConfirm: 'Bạn chắc chắn muốn xóa những bản ghi đã chọn?'
  }
}
